import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewContainerRef, computed } from '@angular/core';
import { CardComponent } from '../card/card.component';
import { MyButtonComponent } from '../../buttons/my-button/my-button.component';
import { MatIconModule } from '@angular/material/icon';
import { SidenavComponent } from 'src/app/layout/sidenav/sidenav.component';
import { TemplatePortal } from '@angular/cdk/portal';
import { SidenavService } from 'src/app/core/services/sidenav.service';
import { FormGroup } from '@angular/forms';
import { CrudService } from 'src/app/core/services/crud.service';
import { CrudSentrynelService } from 'src/app/core/services/crud-sentrynel.service';
import { CrudWszService } from 'src/app/core/services/crud-wsz.service';

@Component({
  selector: 'app-editable-card',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    MatIconModule,
    SidenavComponent,
    MyButtonComponent
  ],
  templateUrl: './editable-card.component.html',
  styleUrl: './editable-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditableCardComponent<TData = any> {
  @Input() title: string = '';
  @Input() icon?: string;
  @Input() actionIcon: string = 'edit_square';
  @Input() form?: FormGroup;
  @Input() formTitle: string = 'modifica';
  @Input() modelId?: number | string;
  @Input() modelIdField: string = 'id';
  @Input() model!: TData | undefined;
  @Output() modelChange = new EventEmitter<TData | undefined>();
  @Input() crud?: CrudService<TData> | CrudSentrynelService<TData> |  CrudWszService<TData>;
  @Input() saveCallback?: Function;
  @Input() reload?: EventEmitter<any>;
  @Input() IsModifyClickable: boolean=true;
  @Input() customActionClick: Function=()=>null;
  @Output() save: EventEmitter<TData> = new EventEmitter<TData>();


  hasCrud = computed(() => {
    return this.crud !== undefined
  });

  constructor(
    protected readonly sidenavService: SidenavService,
    protected readonly vcf: ViewContainerRef
  ) {}

  onActionClick(templateRef: TemplateRef<any>) {
    if(this.IsModifyClickable){
      const portal = new TemplatePortal(templateRef, this.vcf);
      this.sidenavService.pushContent(portal);
    }else{
      this.customActionClick()
    }
    
  }

  onSaveClick() {
    if (this.form?.valid) {
      this.crud?.save(this.form?.value, this.modelId).subscribe((modelValue) => {
        this.sidenavService.clearContents();
        if (this.saveCallback) {
          this.saveCallback(modelValue)
        }
        this.model = modelValue;
        this.modelChange.emit(this.model);
        this.save.emit(modelValue);
        if (this.reload) {
          this.reload.emit();
        }
      });
    }
  }
}
